import { useQueries } from "@tanstack/react-query";
import {
  findCategoryById,
  getCategories,
  findCategoryPathById,
} from "@/data/categories";
import { getProductsSearch } from "@/data/product-search";
import {
  SearchProductsResponse,
  CatalogProductViewResponse,
  GenderItem,
} from "@/types/product-search";
import { Category } from "@/types/homepage";
import { getCategoryMostViewed } from "@/data/category-most-viewed";
import { base64Parser } from "@repo/next-shared/utils/nuqs-custom-parsers";
import { useLocale } from "next-intl";

export function useCategoryPageData(categoryId: string, filters: string) {
  const locale = useLocale().substring(0, 2) as keyof GenderItem;
  const [
    { data: categories, isLoading: isLoadingCategory },
    { data: products, isLoading: isLoadingProducts },
    { data: mostViewed, isLoading: isLoadingMostViewed },
  ] = useQueries({
    queries: [
      {
        queryKey: ["category"],
        queryFn: () => getCategories(),
        select: (categories: Category[]) => ({
          category: findCategoryById(categories, categoryId),
          categoryPath: findCategoryPathById(categories, categoryId),
        }),
        staleTime: 60000 * 120,
      },
      {
        queryKey: ["products", categoryId, base64Parser(filters)],
        queryFn: () =>
          getProductsSearch({ categoryId, ...base64Parser(filters) }, locale),
        select: (data: SearchProductsResponse) => data,
      },
      {
        queryKey: ["mostviewed", categoryId],
        queryFn: () => getCategoryMostViewed(categoryId),
        select: (data: CatalogProductViewResponse) =>
          data.catalogProductViewsList,
      },
    ],
  });

  return {
    categories,
    isLoadingCategory,
    products,
    isLoadingProducts,
    mostViewed,
    isLoadingMostViewed,
  };
}
